module.exports = __webpack_public_path__ + "static/img/zndh.870d1f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zndh.png
// module id = VkhI
// module chunks = 0